import styled from 'styled-components';
import { getThemeColor, getThemeTypography } from 'utils/styled';
import { LIST_ITEM_SPACING_PX } from '../constants';

export const MenuListSectionRoot = styled.ul`
  padding: 0;
  list-style: none;
`;

export const Title = styled.span`
  ${getThemeTypography('h2')};
  color: ${getThemeColor('actionTertiary')};
  font-size: 10px;
  line-height: 1.4;
  align-items: center;
  display: flex;
  font-weight: normal;
  outline: none;
`;

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  padding: 0 ${LIST_ITEM_SPACING_PX}px;
  width: 100%;
`;
